var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{attrs:{"size":"md","tabs":_vm.tabs,"module":`n-box-${_vm.nBoxId}`},on:{"tabChange":function($event){return _vm.$emit('update:value', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }